"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var LogEvent_1 = __importDefault(require("./LogEvent"));
var StatsigIdentity_1 = __importDefault(require("./StatsigIdentity"));
var StatsigLogger_1 = __importDefault(require("./StatsigLogger"));
var StatsigNetwork_1 = __importDefault(require("./StatsigNetwork"));
var StatsigSDKOptions_1 = __importDefault(require("./StatsigSDKOptions"));
var StatsigStore_1 = __importDefault(require("./StatsigStore"));
var StatsigAsyncStorage_1 = __importDefault(require("./utils/StatsigAsyncStorage"));
var MAX_VALUE_SIZE = 64;
var MAX_OBJ_SIZE = 1024;
var StatsigClient = /** @class */ (function () {
    function StatsigClient(sdkKey, user, options) {
        this.appState = null;
        this.currentAppState = null;
        this.initCalled = false;
        this.pendingInitPromise = null;
        if (typeof sdkKey !== 'string' || !sdkKey.startsWith('client-')) {
            throw new Error('Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk');
        }
        this.ready = false;
        this.sdkKey = sdkKey;
        this.options = new StatsigSDKOptions_1.default(options);
        this.identity = new StatsigIdentity_1.default(this.normalizeUser(user !== null && user !== void 0 ? user : null), this.options.getOverrideStableID(), StatsigClient.reactNativeUUID);
        this.network = new StatsigNetwork_1.default(this);
        this.store = new StatsigStore_1.default(this);
        this.logger = new StatsigLogger_1.default(this);
    }
    StatsigClient.prototype.getNetwork = function () {
        return this.network;
    };
    StatsigClient.prototype.getStore = function () {
        return this.store;
    };
    StatsigClient.prototype.getLogger = function () {
        return this.logger;
    };
    StatsigClient.prototype.getOptions = function () {
        return this.options;
    };
    StatsigClient.prototype.getSDKKey = function () {
        if (this.sdkKey == null) {
            return '';
        }
        return this.sdkKey;
    };
    StatsigClient.prototype.getCurrentUser = function () {
        return this.identity.getUser();
    };
    StatsigClient.prototype.getCurrentUserCacheKey = function () {
        var _a, _b;
        return String((_b = (_a = this.identity.getUser()) === null || _a === void 0 ? void 0 : _a.userID) !== null && _b !== void 0 ? _b : '');
    };
    StatsigClient.prototype.getStatsigMetadata = function () {
        return this.identity.getStatsigMetadata();
    };
    StatsigClient.prototype.initializeAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userCacheKey;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.pendingInitPromise != null) {
                            return [2 /*return*/, this.pendingInitPromise];
                        }
                        if (this.ready) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        this.initCalled = true;
                        if (!StatsigAsyncStorage_1.default.asyncStorage) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.identity.initAsync()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.store.loadFromAsyncStorage()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (this.appState &&
                            this.appState.addEventListener &&
                            typeof this.appState.addEventListener === 'function') {
                            this.currentAppState = this.appState.currentState;
                            this.appState.addEventListener('change', this.handleAppStateChange.bind(this));
                        }
                        userCacheKey = this.getCurrentUserCacheKey();
                        this.pendingInitPromise = this.network
                            .fetchValues(this.identity.getUser(), this.options.getInitTimeoutMs(), function (json) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.store.save(userCacheKey, json)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, function (e) { })
                            .catch(function (e) { })
                            .finally(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.pendingInitPromise = null;
                                this.ready = true;
                                this.logger.sendSavedRequests();
                                return [2 /*return*/];
                            });
                        }); });
                        return [2 /*return*/, this.pendingInitPromise];
                }
            });
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @param {boolean} ignoreOverrides = false if this check should ignore local overrides
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */
    StatsigClient.prototype.checkGate = function (gateName, ignoreOverrides) {
        if (ignoreOverrides === void 0) { ignoreOverrides = false; }
        this.ensureStoreLoaded();
        if (typeof gateName !== 'string' || gateName.length === 0) {
            throw new Error('Must pass a valid string as the gateName.');
        }
        return this.store.checkGate(gateName, ignoreOverrides);
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @param {boolean} ignoreOverrides = false if this check should ignore local overrides
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */
    StatsigClient.prototype.getConfig = function (configName, ignoreOverrides) {
        if (ignoreOverrides === void 0) { ignoreOverrides = false; }
        this.ensureStoreLoaded();
        if (typeof configName !== 'string' || configName.length === 0) {
            throw new Error('Must pass a valid string as the configName.');
        }
        return this.store.getConfig(configName, ignoreOverrides);
    };
    /**
     * Gets the experiment for a given user
     * @param {string} experimentName - the name of the experiment to get
     * @param {boolean} keepDeviceValue = false if this should use "sticky" values persisted in local storage
     * @param {boolean} ignoreOverrides = false if this check should ignore local overrides
     * @returns {DynamicConfig} - value of the experiment for the user, represented by a Dynamic Config object
     * @throws Error if initialize() is not called first, or experimentName is not a string
     */
    StatsigClient.prototype.getExperiment = function (experimentName, keepDeviceValue, ignoreOverrides) {
        if (keepDeviceValue === void 0) { keepDeviceValue = false; }
        if (ignoreOverrides === void 0) { ignoreOverrides = false; }
        this.ensureStoreLoaded();
        if (typeof experimentName !== 'string' || experimentName.length === 0) {
            throw new Error('Must pass a valid string as the experimentName.');
        }
        return this.store.getExperiment(experimentName, keepDeviceValue, ignoreOverrides);
    };
    StatsigClient.prototype.logEvent = function (eventName, value, metadata) {
        if (value === void 0) { value = null; }
        if (metadata === void 0) { metadata = null; }
        if (!this.logger || !this.sdkKey) {
            throw new Error('Must initialize() before logging events.');
        }
        if (typeof eventName !== 'string' || eventName.length === 0) {
            console.error('Event not logged. No valid eventName passed.');
            return;
        }
        if (this.shouldTrimParam(eventName, MAX_VALUE_SIZE)) {
            console.warn('eventName is too long, trimming to ' + MAX_VALUE_SIZE + ' characters.');
            eventName = eventName.substring(0, MAX_VALUE_SIZE);
        }
        if (typeof value === 'string' &&
            this.shouldTrimParam(value, MAX_VALUE_SIZE)) {
            console.warn('value is too long, trimming to ' + MAX_VALUE_SIZE + '.');
            value = value.substring(0, MAX_VALUE_SIZE);
        }
        if (this.shouldTrimParam(metadata, MAX_OBJ_SIZE)) {
            console.warn('metadata is too big. Dropping the metadata.');
            metadata = { error: 'not logged due to size too large' };
        }
        var event = new LogEvent_1.default(eventName);
        event.setValue(value);
        event.setMetadata(metadata);
        event.setUser(this.getCurrentUser());
        this.logger.log(event);
    };
    StatsigClient.prototype.updateUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var currentUser, userCacheKey;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.initCalled) {
                            throw new Error('Call initialize() first.');
                        }
                        this.identity.updateUser(this.normalizeUser(user));
                        currentUser = this.identity.getUser();
                        userCacheKey = this.getCurrentUserCacheKey();
                        if (!(this.pendingInitPromise != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.pendingInitPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.pendingInitPromise = this.network
                            .fetchValues(currentUser, this.options.getInitTimeoutMs(), function (json) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.store.save(userCacheKey, json)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, function (e) {
                            throw e;
                        })
                            .finally(function () {
                            _this.pendingInitPromise = null;
                        });
                        return [2 /*return*/, this.pendingInitPromise
                                .then(function () {
                                return Promise.resolve(true);
                            })
                                .catch(function () {
                                return Promise.resolve(false);
                            })];
                }
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */
    StatsigClient.prototype.shutdown = function () {
        this.logger.flush(true);
        if (this.appState &&
            this.appState.removeEventListener &&
            typeof this.appState.removeEventListener === 'function') {
            this.appState.removeEventListener('change', this.handleAppStateChange.bind(this));
        }
    };
    /**
     * Stores a local gate override
     * @param gateName the gate to override
     * @param value the value to override the gate to
     */
    StatsigClient.prototype.overrideGate = function (gateName, value) {
        this.ensureStoreLoaded();
        this.store.overrideGate(gateName, value);
    };
    /**
     * Stores a local config override
     * @param gateName the config to override
     * @param value the json value to override the config to
     */
    StatsigClient.prototype.overrideConfig = function (configName, value) {
        this.ensureStoreLoaded();
        this.store.overrideConfig(configName, value);
    };
    /**
     * Removes the given gate override
     * @param gateName
     */
    StatsigClient.prototype.removeGateOverride = function (gateName) {
        this.ensureStoreLoaded();
        this.store.removeGateOverride(gateName);
    };
    /**
     * Removes the given config override
     * @param configName
     */
    StatsigClient.prototype.removeConfigOverride = function (configName) {
        this.ensureStoreLoaded();
        this.store.removeConfigOverride(configName);
    };
    /**
     * @deprecated - use removeGateOverride or removeConfig override
     * Removes the given gate override
     * @param gateName
     */
    StatsigClient.prototype.removeOverride = function (gateName) {
        this.ensureStoreLoaded();
        this.store.removeGateOverride(gateName);
    };
    /**
     * @deprecated - use getAllOverrides to get gate and config overrides
     * @returns Gate overrides
     */
    StatsigClient.prototype.getOverrides = function () {
        this.ensureStoreLoaded();
        return this.store.getAllOverrides().gates;
    };
    /**
     * @returns The local gate and config overrides
     */
    StatsigClient.prototype.getAllOverrides = function () {
        this.ensureStoreLoaded();
        return this.store.getAllOverrides();
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */
    StatsigClient.prototype.getStableID = function () {
        return this.identity.getStatsigMetadata().stableID;
    };
    StatsigClient.prototype.initializeCalled = function () {
        return this.initCalled;
    };
    // All methods below are for the statsig react native SDK internal usage only!
    StatsigClient.prototype.setSDKPackageInfo = function (sdkPackageInfo) {
        if (sdkPackageInfo != null) {
            this.identity.setSDKPackageInfo(sdkPackageInfo);
        }
    };
    StatsigClient.setAsyncStorage = function (asyncStorage) {
        if (asyncStorage != null) {
            StatsigAsyncStorage_1.default.asyncStorage = asyncStorage;
        }
    };
    StatsigClient.setReactNativeUUID = function (uuid) {
        if (uuid != null) {
            StatsigClient.reactNativeUUID = uuid;
        }
    };
    StatsigClient.prototype.setAppState = function (appState) {
        if (appState != null) {
            this.appState = appState;
        }
    };
    StatsigClient.prototype.setNativeModules = function (nativeModules) {
        if (nativeModules != null) {
            this.identity.setNativeModules(nativeModules);
        }
    };
    StatsigClient.prototype.setPlatform = function (platform) {
        if (platform != null) {
            this.identity.setPlatform(platform);
        }
    };
    StatsigClient.prototype.setRNDeviceInfo = function (deviceInfo) {
        if (deviceInfo != null) {
            this.identity.setRNDeviceInfo(deviceInfo);
        }
    };
    StatsigClient.prototype.setExpoConstants = function (expoConstants) {
        if (expoConstants != null) {
            this.identity.setExpoConstants(expoConstants);
        }
    };
    StatsigClient.prototype.setExpoDevice = function (expoDevice) {
        if (expoDevice != null) {
            this.identity.setExpoDevice(expoDevice);
        }
    };
    StatsigClient.prototype.handleAppStateChange = function (nextAppState) {
        var _a;
        if (this.currentAppState === 'active' &&
            nextAppState.match(/inactive|background/)) {
            this.logger.flush(true);
        }
        else if (((_a = this.currentAppState) === null || _a === void 0 ? void 0 : _a.match(/inactive|background/)) &&
            nextAppState === 'active') {
            this.logger.sendSavedRequests();
        }
        this.currentAppState = nextAppState;
    };
    StatsigClient.prototype.shouldTrimParam = function (entity, size) {
        if (entity == null)
            return false;
        if (typeof entity === 'string')
            return entity.length > size;
        if (typeof entity === 'object') {
            return JSON.stringify(entity).length > size;
        }
        if (typeof entity === 'number')
            return entity.toString().length > size;
        return false;
    };
    StatsigClient.prototype.normalizeUser = function (user) {
        user = this.trimUserObjIfNeeded(user);
        if (this.options.getEnvironment() != null) {
            // @ts-ignore
            user.statsigEnvironment = this.options.getEnvironment();
        }
        return user;
    };
    StatsigClient.prototype.trimUserObjIfNeeded = function (user) {
        var _a, _b;
        if (user == null) {
            return {};
        }
        if (this.shouldTrimParam((_a = user.userID) !== null && _a !== void 0 ? _a : null, MAX_VALUE_SIZE)) {
            console.warn('User ID is too large, trimming to ' + MAX_VALUE_SIZE + 'characters');
            user.userID = (_b = user.userID) === null || _b === void 0 ? void 0 : _b.toString().substring(0, MAX_VALUE_SIZE);
        }
        if (this.shouldTrimParam(user, MAX_OBJ_SIZE)) {
            user.custom = {};
            if (this.shouldTrimParam(user, MAX_OBJ_SIZE)) {
                console.warn('User object is too large, only keeping the user ID.');
                user = { userID: user.userID };
            }
            else {
                console.warn('User object is too large, dropping the custom property.');
            }
        }
        return user;
    };
    StatsigClient.prototype.ensureStoreLoaded = function () {
        if (!this.store.isLoaded()) {
            throw new Error('Call and wait for initialize() to finish first.');
        }
    };
    return StatsigClient;
}());
exports.default = StatsigClient;
